import PropTypes from 'prop-types';

const propType = {
  code: PropTypes.string,
  discountValue: PropTypes.number,
};

export default { propType };
